// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { Glyphicon } from 'react-bootstrap';
import '../../styles/components/LoaderButton.css';

export default () => (
  <Glyphicon
    key={0}
    glyph='refresh'
    style={{
      display: 'block',
      marginLeft: 'auto',
      width: '50px',
      height: '50px',
      marginTop: '25%',
      marginRight: 'auto',
    }}
    className='spinning'
  />
);
